import { Text } from 'shared/components/ui';
import { SearchTagV2Disabled } from 'features/search';

import styles from './index.module.scss';

interface Props {
	tags: string[];
	filters?: boolean;
	peopleFilters: string[];
	companiesFilters: string[];
	handleChangeFilters: () => void;
	handleRefineCriteria: () => void;
}

export const ResultsSidebar = ({
	tags,
	filters,
	peopleFilters,
	companiesFilters,
	handleChangeFilters,
	handleRefineCriteria
}: Props) => {
	const handleRemoveTag = () => {
		return;
	};

	const handleRemoveFilter = () => {
		return;
	};

	return (
		<div className={styles.sidebar}>
			<div className={styles.header}>
				<Text variant="inter/18/semi">Search Criteria</Text>
				<Text variant="inter/14/medium" color="grey">
					{tags.length + companiesFilters.length + peopleFilters.length}
				</Text>
			</div>
			<div className={styles.filters}>
				<div className={styles.section}>
					<div className={styles.title}>
						<div className={styles.titleInline}>
							<Text variant="inter/15/semi">Technology skills</Text>
							<Text variant="inter/14/medium" color="grey">
								{tags.length}
							</Text>
						</div>
						<div className={styles.button} onClick={handleRefineCriteria}>
							<Text variant="inter/15/semi">Refine Skills</Text>
						</div>
					</div>
					<div className={styles.tags}>
						{tags.map(tag => (
							<SearchTagV2Disabled key={tag} text={tag} onClick={handleRemoveTag} card />
						))}
					</div>
				</div>
				{((peopleFilters && peopleFilters.length > 0) || (companiesFilters && companiesFilters.length > 0)) && (
					<div className={styles.section}>
						<div className={styles.title}>
							<div className={styles.titleInline}>
								<Text variant="inter/15/semi">Filters</Text>
								<Text variant="inter/14/medium" color="grey">
									{peopleFilters.length + companiesFilters.length}
								</Text>
							</div>
							<div className={styles.button} onClick={handleChangeFilters}>
								<Text variant="inter/15/semi">Refine Filters</Text>
							</div>
						</div>
						<div className={styles.sectionWrapper}>
							{companiesFilters && companiesFilters.length > 0 && (
								<div className={styles.section}>
									<Text variant="inter/15/regular" color="grey" className={styles.sectionTitle}>
										Company
									</Text>
									<div className={styles.tags}>
										{companiesFilters.map(tag => (
											<SearchTagV2Disabled
												key={tag}
												text={tag}
												onClick={handleRemoveFilter}
												card
											/>
										))}
									</div>
								</div>
							)}
							{peopleFilters && peopleFilters.length > 0 && (
								<div className={styles.section}>
									<Text variant="inter/15/regular" color="grey" className={styles.sectionTitle}>
										People
									</Text>
									<div className={styles.tags}>
										{peopleFilters.map(tag => (
											<SearchTagV2Disabled
												key={tag}
												text={tag}
												onClick={handleRemoveFilter}
												card
											/>
										))}
									</div>
								</div>
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
